export default __webpack_public_path__ + "static/media/cake.947eb0f3.png";